export default "__VITE_ASSET__DwE3Z78S__"